import one from "../../../assets/images/one.svg";
import two from "../../../assets/images/two.svg";
import three from "../../../assets/images/three.svg";
import four from "../../../assets/images/four.svg";
import five from "../../../assets/images/five.svg";
import oneColored from "../../../assets/images/oneColored.svg";
import twoColored from "../../../assets/images/twoColored.svg";
import threeColored from "../../../assets/images/threeColored.svg";
import fourColored from "../../../assets/images/fourColored.svg";
import fiveColored from "../../../assets/images/fiveColored.svg";
import styles from "./styles.module.css";
import { Button } from "react-bootstrap";

export function Rating({
  rating,
  handleRateChange,
  submitRating,
  rated,
  isRating,
}) {
  const _rating = rating ? rating - 1 : -1;
  const uncolored = [one, two, three, four, five];
  const colored = [
    oneColored,
    twoColored,
    threeColored,
    fourColored,
    fiveColored,
  ];
  const messages = ["Terrible", "Bad", "Okay", "Good", "Great"];
  const emoteList = (
    <>
      {uncolored.map((emote, idx) => (
        <section className={styles.emote} key={idx}>
          <img
            src={idx === rating - 1 ? colored[_rating] : emote}
            alt={"Emote"}
            key={idx}
            className={styles.img}
            onClick={() => {
              if (rated) {
                return;
              }
              handleRateChange(idx + 1);
            }}
          />
          <p
            className={styles.message}
            style={{
              color: idx === rating - 1 ? "#165226" : "",
              fontWeight: idx === rating - 1 ? "600" : "",
            }}
          >
            {messages[idx]}
          </p>
        </section>
      ))}
    </>
  );
  return (
    <section className={styles.ratings}>
      <section className={styles.emotes}>{emoteList}</section>
      <Button
        style={{
          backgroundColor: "#165226",
          borderColor: "#165226",
        }}
        onClick={(e) => {
          if (isRating) {
            return;
          }
          submitRating();
        }}
        disabled={rated}
      >
        {isRating ? "Rating..." : "Rate Us"}
      </Button>
    </section>
  );
}
